import { Button, Card, Col, Row, useModal } from '@pankod/refine-antd'
import { IResourceComponentsProps, useShow } from '@pankod/refine-core'
import { EstimatedCosts } from 'components/orders/EstimatedCosts'
import { OrderItems } from 'components/orders/items'
import { Supplements } from 'components/orders/supplements'
import { OrderDetails } from 'components/orders/details'
import { WarehouseReviewDecisionBanner } from 'components/orders/WarehouseReviewDecision'
import { WarehouseNotesModal } from 'components/orders/WarehouseNotesModal'
import { UserAddresses } from 'components/orders/user_addresses'
import { currentUserMetadata } from 'utility/authLocal'
import { WAREHOUSE_ROLE_ID } from 'utility/constants'

// Warehouse uses the same order source as the standard detail view. The mode
// only limits what is rendered and can be operated by the Warehouse role.
export const WarehouseOrderShow: React.FC<IResourceComponentsProps> = () => {
  const { modalProps: warehouseNotesProps, show: showWarehouseNotes, close: closeWarehouseNotes } = useModal()
  const addressFields = 'id, email, name, surnames, phone_number, nif, additional_info, is_company, full_address, postal_code, island_id'
  const { queryResult } = useShow<any>({
    resource: 'orders',
    metaData: {
      select:
        '*, shipments(id, shipped_by, tracking_id, processed_at), payment_method(id, name), invoices:invoice_id(id, invoice_number, reviewed), user(id, name, email, wallet_balance, created_at, gender, birthday, referred_by_user_id(referral_benefits!referrer_user_id(id, benefit_amount)), referral_benefits!referrer_user_id(status, benefit_amount),' +
        'orders!user(id, total, created_at, status_id, syniva_price, shipping_price, shipping_insurance_price, custom_order_price, wallet_amount_used,' +
        'supplements(supplement, volumetric, deleted), items(shipping_price_to_madrid), marketplace_id(id, shipment_price, free_shipment_price))), administrator(id, name), credit_card(number),' +
        'shipping_method_id, status(id, name), shipping_method(name, shipment_type, shipMode, price, volumetric_factor, price_additional_kg, shipping_method_price_ranges(*)),' +
        `shipping_address(${addressFields}, island(name, boat_extra_cost, plane_extra_cost)), billing_address(${addressFields}),
        subscriptions(id, name),
        supplements(id, status_id, volumetric, billable_volume, supplement, description, deleted, volumetricInfo, parent, created_at), estimated_costs(id, status_id), refunds(*), wallet_amount_used,
        items(id, name, url, custom_order_site, shipping_price_to_madrid, price, disabled, syniva_price, iva, quantity, igic_price, igic_percent, tariff_price, delivered_warehouse, has_accessories, returned, seller, cloned_from, reviewed, order_id, deleted),
        marketplace_id(id, shipment_price, free_shipment_price, cif, legal_name, legal_address, province, postal_code, extra_info, is_custom_shop, iva_percent, igic_types(id, value)),
        issues(id, issue_type_id, issue_sub_type_id, created_at, reason, is_opened)`
    }
  })
  const order = queryResult.data?.data

  if (!order) return <></>
  order.supplements = (order.supplements || []).filter((item: any) => !item.deleted)
  order.items = (order.items || []).filter((item: any) => !item.deleted)

  return <>
    <Row gutter={[12, 12]} align="stretch">
      <Col xl={7} lg={24} xs={24} style={{ display: 'flex', flexDirection: 'column' }}>
        <UserAddresses order={order} canEdit warehouseMode />
      </Col>
      <Col xl={17} xs={24}>
        <OrderDetails
          order={order}
          refetchFn={queryResult.refetch}
          warehouseMode
          warehouseDecisionContent={<>
            <div style={{ marginTop: 12, minHeight: 72, display: 'flex', alignItems: 'center' }}>
              <WarehouseReviewDecisionBanner order={order} />
            </div>
            <Card
              size="small"
              style={{
                marginTop: 12,
                borderColor: order?.warehouseNote?.trim() ? '#fa8c16' : undefined,
                backgroundColor: '#fff'
              }}
            >
              <Button danger={!!order?.warehouseNote?.trim()} onClick={showWarehouseNotes}>
                Notas almacén
              </Button>
              {order?.warehouseNote?.trim() && <div style={{ marginTop: 8, whiteSpace: 'pre-wrap' }}>{order.warehouseNote}</div>}
            </Card>
          </>}
        />
      </Col>
    </Row>
    <WarehouseNotesModal
      modalProps={warehouseNotesProps}
      close={closeWarehouseNotes}
      orderId={order.id}
      note={order.warehouseNote || ''}
      updateOrderValue={queryResult.refetch}
    />
    <Row gutter={[12, 12]} style={{ marginTop: 12 }}><Col xl={24}><OrderItems order={order} orderQuery={queryResult as any} warehouseMode /></Col></Row>
    <Row gutter={[12, 12]} style={{ marginTop: 12 }}><Col xl={24}><Supplements order={order} orderQuery={queryResult as any} setSupQuery={() => undefined} warehouseMode /></Col></Row>
    <Row gutter={[12, 12]} style={{ marginTop: 12 }}><Col xl={24}><EstimatedCosts order={order} orderQuery={queryResult as any} setSupQuery={() => undefined} readOnly /></Col></Row>
  </>
}

export const isWarehouseUser = () => Number(currentUserMetadata()?.role_id) === WAREHOUSE_ROLE_ID
